import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: calc(28% + 80px);

  @media screen and (max-width: 1256px) {
    flex-grow: 1;
    flex-direction: row;
    padding: 10px 0 10px 0;
  }

  @media screen and (max-width: 743px) {
    flex-direction: column;
    padding: 0 0 10px 0;
    width: 100%;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 32px;

  @media screen and (max-width: 743px) {
    justify-content: flex-start;
    gap: 12px;
  }
`;

export const ColumnLeft = styled.div`
  display: flex;
  align-items: center;
  text-align: left;
`;

export const ColumnRight = styled.div`
  display: flex;
  align-items: center;
`;

export const Heading = styled.span`
  color: var(--Neutral-900, var(--Color-2, #171717));
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;

  @media (min-width: 744px) and (max-width: 1024px) {
    width: 90%;
  }
`;

export const Text = styled.span`
  color: var(--Neutral-900, var(--Color-2, #171717));
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  word-break: break-word;
`;

export const EditButton = styled.button`
  background-color: transparent;
  border: none;
  color: #1271A6;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  padding: 0;
`;

export const CancelButton = styled.button`
  background-color: transparent;
  border: none;
  color: #64748B;
  font-family: Inter;
  font-size: 14px;
  line-height: 21px;
  padding: 0;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media screen and (max-width: 743px) {
    gap: 8px;
  }
`;

export const Body = styled.div``;

export const BodyText = styled.p`
  display: inline-block;
  padding: 12px;
  color: var(--Neutral-900, #171717);
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  word-break: break-word;
  margin-bottom: 0;
  cursor: pointer;
`;